import { useEffect, useState } from 'react'
import { getDocument } from 'services/firestore'

const useGetCustomerProfileDesigns = (customerProfile) => {
  const [designs, setDesigns] = useState([])
  const [loading, setLoading] = useState(!!customerProfile?.designIds?.length)

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true)
      const promises = customerProfile.designIds.map((design) =>
        getDocument('designs', design)
      )
      const data = await Promise.all(promises)
      setDesigns(data)
      setLoading(false)
    }

    customerProfile?.designIds?.length && fetchData()
  }, [customerProfile])

  return [designs, loading]
}

export default useGetCustomerProfileDesigns
